// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"0be9adb4","260":"06fb1e51","313":"b6271571","399":"7bbaeb78","494":"995985ec","533":"a428462d","976":"2af2dc16"}[chunkId] + ".chunk.js";
};